import { useEffect, useState } from "react";

const navItems = [
  { label: "正在热播", href: "#airing" },
  { label: "最新更新", href: "#latest" },
  { label: "高分推荐", href: "#top-rated" },
  { label: "全集资源", href: "#library" },
  { label: "独播剧场", href: "#exclusive" },
  { label: "人气榜单", href: "#ranking" },
  { label: "选剧指南", href: "#guides" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/80"
          : "bg-gradient-to-b from-foreground-950/45 to-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-movie-2-line text-lg" aria-hidden="true" />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-base ${
                light ? "text-background-50" : "text-foreground-950"
              }`}
            >
              韩剧TV
            </span>
            <span
              className={`text-[10px] font-label tracking-wide ${
                light ? "text-background-50/70" : "text-foreground-500"
              }`}
            >
              HANJU TV
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="页面分区导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3 py-2 rounded-md text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                light
                  ? "text-background-50/90 hover:text-background-50 hover:bg-background-50/15"
                  : "text-foreground-700 hover:text-primary-700 hover:bg-primary-100/70"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#airing"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-label font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line text-base" aria-hidden="true" />
            立即追剧
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="切换导航菜单"
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 rounded-md flex items-center justify-center transition-colors cursor-pointer ${
              light
                ? "text-background-50 hover:bg-background-50/15"
                : "text-foreground-800 hover:bg-background-200"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open ? (
        <div
          className={`lg:hidden border-t px-4 py-3 ${
            light
              ? "border-background-50/20 bg-foreground-950/90 backdrop-blur"
              : "border-background-200/80 bg-background-50/98 backdrop-blur"
          }`}
        >
          <nav className="grid grid-cols-2 gap-2" aria-label="移动端分区导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className={`px-3 py-2.5 rounded-md text-sm font-label transition-colors cursor-pointer ${
                  light
                    ? "text-background-50 bg-background-50/10 hover:bg-background-50/20"
                    : "text-foreground-800 bg-background-100 hover:bg-primary-100/70 hover:text-primary-700"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}